import {
  FC,
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react'

import { config } from 'config'
import { GlobalStyle } from 'styles/global'
import { Loader } from 'components/loader'

type DataContextType = {
  articles: any[]
  appLocale: typeof config.locale
}

const DataContext = createContext<DataContextType | null>(null)

export const DataProvider: FC<{
  children?: ReactNode | ReactNode[]
}> = ({ children }) => {
  const params = new URLSearchParams(window.location.search)
  const appLocale = (params.get('lang') ||
    config.locale) as typeof config.locale
  const [articles, setArticles] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    fetch('./static/data.json')
      .then(data => data.json())
      .then(json => console.log('data:', json))
      .catch(console.log)
      .finally(() => setIsLoading(false))
  }, [])

  return isLoading ? (
    <>
      <GlobalStyle />
      <Loader />
    </>
  ) : (
    <DataContext.Provider
      value={{
        articles,
        appLocale,
      }}
    >
      {children}
    </DataContext.Provider>
  )
}

export const useDataContext = () => {
  const context = useContext(DataContext)
  return context as DataContextType
}
